export default __webpack_public_path__ + "static/media/newspaper.ac292bc1.png";